import APIClient, { failSafe, makeCancellableAPIRequest } from "./index";

const PolicyAPI = {
    getAll(queryParams = {}){
        return failSafe(
            APIClient.get("/compliance/policies",  {params: queryParams})
        );
    },
    get(id){
        return makeCancellableAPIRequest(
            "GET",
            `/compliance/policies/${id}`
        );
    },
    update(id, data) {
        return failSafe(
            APIClient.put(`/compliance/policies/${id}`, data)
        )
    },
    create(data) {
        return failSafe(
            APIClient.post(`/compliance/policies`, data)
        )
    },
    delete(id) {
        return failSafe(
            APIClient.delete(`/compliance/policies/${id}`)
        )
    },
    getAllRules() {
        return failSafe(
            APIClient.get("compliance/rules?length=1000")
        )
    },
    getEvents(policyId) {
        return failSafe(
            APIClient.get(`compliance/policies/${policyId}/events`)
        )
    },        
    getFilters() {
        return makeCancellableAPIRequest(
            "GET",
            "/compliance/policies-filters"
        )
    },
    uploadCustomPolicyCSV(data) {
        return makeCancellableAPIRequest(
            "POST",
            "/compliance/policies/upload",
            {
                data,
                headers: {
                    'content-type': 'multipart/form-data'
                }
            },
        )
    }
}

export const PolicyEnvAPI = {
    get(id) {
        return failSafe(
            APIClient.get(`/compliance/policies/${id}/appEnvs`)
        )
    },
    async update(id, data) {
        const response = APIClient.post(`/compliance/policies/${id}/appEnvs`, data)
        return response
    }
}

export default PolicyAPI;